/* 用法示例： 
<input type="text" class="do-input w200" placeholder="应用名称" appKeydownSearch (fromChild)=updateList($event)> 
备注：updateList()接收广播的对象{enterIs:boolen},page.fn()可放在updateList()里，此函数名称可更改；
    (fromChild)固定，不可修改。
*/
import { Directive, HostListener, ElementRef, EventEmitter,Output} from '@angular/core';

@Directive({
  selector: '[appKeydownSearch]'
})
export class KeydownSearchDirective {
  @Output() fromChild = new EventEmitter();
  constructor(private ele: ElementRef) {}
  @HostListener('keydown',['$event'])
  onKeyDown(event: KeyboardEvent) {
    if(event.keyCode == 13){
      this.fromChild.emit({
        enterIs:true
      });
    }else{
      this.fromChild.emit({
        enterIs:false
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/component/shared/keydown-search.directive.ts